import { useParams } from "react-router";
import { MatchDetailShowcase } from "@/app/(app)/preview/match-detail/_components/match-detail-showcase";
import { getVariant } from "@/app/(app)/preview/match-detail/_data/variants";
import NotFoundPage from "../_errors/NotFoundPage";

export default function MatchDetailVariantPage() {
  const { variant: slug } = useParams();
  const variant = slug ? getVariant(slug) : undefined;
  if (!variant) return <NotFoundPage />;
  return (
    <div className="flex min-h-screen flex-1 flex-col bg-white p-8">
      <MatchDetailShowcase variant={variant} />
    </div>
  );
}
